import React from 'react';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import colors from '../../../../styles/colors';

const Breadcrumb = ({ setSelectedItem, selectedItem }) => (
  <div className="breadcrumb-container" style={{ color: colors.white }}>
    <button
      className="breadcrumb-item"
      style={{
        color: !selectedItem ? colors.white : colors.blueThree
      }}
      onClick={() => {
        setSelectedItem(null);
      }}
    >
      Users
    </button>
    {!!selectedItem && (
      <>
        <Icon name="chevron right" />
        <span className="breadcrumb-item">{selectedItem.email}</span>
      </>
    )}
  </div>
);

Breadcrumb.propTypes = {
  setSelectedItem: PropTypes.func.isRequired,
  selectedItem: PropTypes.object.isRequired
};

export default Breadcrumb;
